import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PressComponent } from './press.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { HeroModule } from '@app/core/components/hero/hero.module';
import { ResourceComponent } from './resource/resource.component';
import { AptitudesComponent } from './aptitudes/aptitudes.component';
import { CardLogotipoComponent } from './card-logotipo/card-logotipo.component';
import { TeamComponent } from './team/team.component';
import { ServiceComponent } from './service/service.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { HelpCardSlideModule } from '../help/components/help-card-slide/help-card-slide.module';
import { HelpCardModule } from '../help/components/help-card/help-card.module';
import { FlyerSaldoModule } from '../../landing-social-proof/components/flyer-saldo/flyer-saldo.module';
import { HelpOptionsModule } from '../../core/components/help-options/help-options.module';
import { NgxCarouselModule } from '../../landing-page/components/user-social/ngx-carousel/ngx-carousel.module';
import { SlideModule } from '../../core/components/slide/slide.module';

const routes: Routes = [
    {
        path: '',
        component: PressComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: []
})
export class PressRoutingModule {}

@NgModule({
    declarations: [PressComponent, CardLogotipoComponent, ResourceComponent, AptitudesComponent, TeamComponent, ServiceComponent],
    exports: [PressComponent],
    imports: [
        CommonModule,
        PressRoutingModule,
        CoreModule,
        MatCardModule,
        MatIconModule,
        HeroModule,
        InfoBlockModule,
        MatButtonModule,
        TranslateModule,
        HelpCardSlideModule,
        SlideModule,
        HelpCardModule,
        FlyerSaldoModule,
        HelpOptionsModule,
        NgxCarouselModule,
        SlideModule
    ]
})
export class PressModule {}
